<form lin-layout-form [formGroup]="form" (ngSubmit)="submitForm()">
  <lin-form-label required>{{ 'CLIENT.VEHICLES.DOCUMENTS.ISSUE_DATE' | translate }}</lin-form-label>
  <lin-datepicker-field formControlName="issueDate" [isPlaceholderShown]="true" [isNoMaxDate]="true"></lin-datepicker-field>

  <mat-checkbox class="form-checkbox" formControlName="noExpiry"> {{ 'CLIENT.VEHICLES.DOCUMENTS.NO_EXPIRY' | translate }} </mat-checkbox>

  <lin-form-label [required]="!isNotExpiring">{{ 'FIELDS.expirationDate' | translate }}</lin-form-label>
  <lin-datepicker-field
    formControlName="expDate"
    [isNoMaxDate]="true"
    [isPlaceholderShown]="true"
    [isDisabled]="isNotExpiring"
    [minDate]="issueDateIsValid ? issueDate.add(1, 'day').format('YYYY/MM/DD HH:mm') : ''"
    [isError]="issueDateIsValid && form?.get('expDate')?.value && !expDateIsValid"
  ></lin-datepicker-field>
  @if (issueDateIsValid && form?.get('expDate')?.value && !expDateIsValid) {
  <mat-error class="lin-autocomplete-error">{{ 'ERRORS.EXP_DATE_NOT_VALID' | translate }}</mat-error>
  }

  <lin-form-label class="cost" [currencyLabel]="true">{{ 'CLIENT.VEHICLES.SERVICE_REMINDERS.COST' | translate }}</lin-form-label>
  <mat-form-field>
    <input matInput formControlName="cost" type="number" min="0" autocomplete="off" />
    <mat-error><lin-form-field-error></lin-form-field-error></mat-error>
  </mat-form-field>

  <lin-form-label>{{ 'FIELDS.NOTE' | translate }}</lin-form-label>
  <mat-form-field>
    <textarea matInput rows="7" formControlName="note"></textarea>
  </mat-form-field>

  <lin-form-file-picker formControlName="files">
    @if (data?.files) { @for (file of (data?.files); track file.id) { @if (!form.get('removeFiles').value.includes(file.id)) {
    <lin-form-file-row name="{{ file.displayName }}" url="{{ file.path + file.name }}" (delete)="removeFile(file.id)"></lin-form-file-row>
    } } }
  </lin-form-file-picker>

  <lin-form-submit-button class="add-document-button" [isLoading]="false" [isDisabled]="!this.issueDateIsValid || !this.expDateIsValid"
    >{{ 'CLIENT.VEHICLES.DOCUMENTS.EDIT_RECORD' | translate }}</lin-form-submit-button
  >
</form>
